/** Zone géographique d'un sujet de Baccalauréat (aligné sur l'enum Prisma `BacZone`) */
export enum BacZone {
  International = 'International',
  AmeriqueNord = 'AmeriqueNord',
  AmeriqueSud = 'AmeriqueSud',
  Polynesie = 'Polynesie',
  NouvelleCaledonie = 'NouvelleCaledonie',
  CentresEtrangers = 'CentresEtrangers',
  Asie = 'Asie',
  Metropole = 'Metropole',
}

/** Ordre d'affichage dans le catalogue annales */
export const BAC_ZONE_CATALOGUE_ORDER: readonly BacZone[] = [
  BacZone.Metropole,
  BacZone.AmeriqueNord,
  BacZone.AmeriqueSud,
  BacZone.Polynesie,
  BacZone.NouvelleCaledonie,
  BacZone.CentresEtrangers,
  BacZone.Asie,
  BacZone.International,
];
